var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "column content page",
    attrs: {
      "id": "exhibit-page"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("We purposefully selected graduates from a diverse range of design-related courses and institutions in the capital, hoping to demonstrate the breadth of design work currently being nurtured in London. We encourage you to further explore their work.")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "artists"
    }
  }, _vm._l((_vm.exhibit), function(artist) {
    return _c('exhibit-item', {
      key: artist.index,
      attrs: {
        "artist": artist
      }
    })
  }))])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("70 "), _c('sup', [_vm._v("×")]), _vm._v(" 40 "), _c('sup', [_vm._v("×")]), _vm._v(" 50")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("We invited eight recent graduates from London-based craft or industrial design courses to present a sample of their work in these diminutive display boxes; just 70 "), _c('sup', [_vm._v("×")]), _vm._v(" 40 "), _c('sup', [_vm._v("×")]), _vm._v(" 50 cm. Although small, the spaces provide a genuine platform for these, some of the city’s freshest new talents, to communicate a ‘taste’ of their ideas, solutions, motivations and preoccupations during London Design Festival.")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74c55ca0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExhibitPage/ExhibitPage.vue
// module id = EEDE
// module chunks = 1